import { graphql } from '../../schemas/server_admin_query'

export const query_external_financial_accounts = graphql(`
  query ExternalFinancialAccounts($ids: [ID!]) {
    external_financial_accounts(ids: $ids) {
      nodes {
        id
        name
        current_balance
        available_balance
        currency
        custodian
        updated_at
        updated_by
        fund_id
      }
    }
  }
`)

export const query_external_financial_account = graphql(`
  query ExternalFinancialAccount($id: ID!) {
    external_financial_account(id: $id) {
      id
      name
      current_balance
      available_balance
      currency
      custodian
      updated_at
      updated_by
      fund_id
    }
  }
`)

export const mutation_update_external_financial_account = graphql(`
  mutation UpdateExternalFinancialAccount(
    $id: String!
    $current_balance: Float!
    $available_balance: Float!
  ) {
    update_external_financial_account(
      id: $id
      current_balance: $current_balance
      available_balance: $available_balance
    ) {
      external_financial_account {
        id
        name
        current_balance
        available_balance
        currency
        custodian
        updated_at
        updated_by
        fund_id
      }
      external_financial_balance_update {
        id
        old_balance
        new_balance
        updated_by
        created_at
      }
      errors
    }
  }
`)
